import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon, SparklesIcon, ArrowUpRightIcon } from 'lucide-react';
interface QuickLink {
  label: string;
  href: string;
}
const QUICK_LINKS: QuickLink[] = [{
  label: 'Qué incluye',
  href: '#incluye'
}, {
  label: 'Los 6 tomos',
  href: '#tomos'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}, {
  label: 'Acceder al Mega Pack',
  href: '#comprar'
}];
const LEGAL_LINKS: QuickLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Política de reembolso',
  href: '#faq'
}];
export function Footer() {
  return <footer className="relative overflow-hidden bg-blush" data-id="element-105" data-mp="3lgop4lv2k8qa">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-rose/30 to-transparent" aria-hidden data-id="element-106" data-mp="3qc40961ozqj0" />
      <div className="pointer-events-none absolute -bottom-28 -right-20 h-72 w-72 rounded-full bg-rose-soft/20 blur-3xl" aria-hidden data-id="element-107" data-mp="29xlzsm95j0i1" />

      <div className="relative mx-auto max-w-6xl px-5 py-14 sm:py-16" data-id="element-108" data-mp="3l90lhpgqmmw3">
        <div className="grid gap-10 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-109" data-mp="3lbdcst8dy9lt">
          {/* Marca y producto */}
          <div className="md:col-span-1" data-id="element-110" data-mp="3v7q7nufo2ti5">
            <p className="font-display text-2xl leading-tight text-ink" data-id="element-111" data-mp="3v8rl25k5ns31">
              Estética Digital{' '}
              <span className="bg-gradient-to-r from-[#3e4ee9] via-[#9750d8] to-[#ff7396] bg-clip-text text-transparent" data-id="element-112" data-mp="3q7txtekag7uo">
                PRO
              </span>
            </p>
            <p className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-rose/20 bg-white px-3 py-1 text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-rose-deep" data-id="element-113" data-mp="34p6x15ihif3">
              <SparklesIcon className="h-3 w-3 text-rose" aria-hidden data-id="element-114" data-mp="ctgwj2n3nqmu" />
              Mega Pack 6 en 1
            </p>
            <p className="mt-3 text-sm font-medium text-ink/70" data-id="element-115" data-mp="qub81u5g27pq">
              Mega Pack 6 en 1 para convertir seguidores en pacientes
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink/60" data-id="element-116" data-mp="tv4mo01f303y">
              Recursos prácticos para ayudar a profesionales de la estética a mejorar su presencia
              digital, crear contenido estratégico y convertir consultas en nuevos turnos.
            </p>
          </div>

          {/* Enlaces rápidos */}
          <nav aria-label="Enlaces rápidos" data-id="element-117" data-mp="18k92xboniu9f">
            <h2 className="text-xs font-bold uppercase tracking-[0.18em] text-rose-deep" data-id="element-118" data-mp="18m3sx4es5ckd">
              Explorá el pack
            </h2>
            <ul className="mt-4 space-y-2.5" data-id="element-119" data-mp="1hk5ylx9gktdz">
              {QUICK_LINKS.map(link => <li key={link.label} data-id="element-120" data-mp="1mk1sv4sct6gc">
                  <a href={link.href} className="group inline-flex items-center gap-1.5 text-sm text-ink/70 transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-121" data-mp="1ml3e223339bs">
                    {link.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5 text-rose/50 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-rose" aria-hidden data-id="element-122" data-mp="3tc2wl1oskzh6" />
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Soporte */}
          <div data-id="element-123" data-mp="1wp0ebledye4q">
            <h2 className="text-xs font-bold uppercase tracking-[0.18em] text-rose-deep" data-id="element-124" data-mp="1wpjtiucniof2">Soporte</h2>
            <ul className="mt-4 space-y-2.5 text-sm" data-id="element-125" data-mp="2td6k4bn1nckl">
              <li data-id="element-126" data-mp="2pc4mfz8rz8kq">
                <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 text-ink/70 transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-127" data-mp="2pdpffkffyjgh">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-128" data-mp="18zpjslnmpfz1">
                    <MailIcon className="h-4 w-4 text-rose" aria-hidden data-id="element-129" data-mp="1414h8fkwmk7f" />
                  </span>
                  soporte@creativodigital.shop
                </a>
              </li>
              <li data-id="element-130" data-mp="2wo0t0itdf2bt">
                <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-ink/70 transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-131" data-mp="2wokda66hu2t0">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-132" data-mp="3fkiu3qu40ekq">
                    <InstagramIcon className="h-4 w-4 text-rose" aria-hidden data-id="element-133" data-mp="31nwy6ldt0zsy" />
                  </span>
                  @creativodigitalstudio
                </a>
              </li>
              <li data-id="element-134" data-mp="1q52k698d2ots">
                <a href="https://creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-ink/70 transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-135" data-mp="1q8qevbpjlha3">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-136" data-mp="1wm44dqsjuitl">
                    <GlobeIcon className="h-4 w-4 text-rose" aria-hidden data-id="element-137" data-mp="1rlge57c5a60f" />
                  </span>
                  creativodigital.shop
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legales */}
        <ul className="mt-10 flex flex-wrap gap-x-5 gap-y-2 text-xs text-ink/45" data-id="element-138" data-mp="1dob99ao63d6r">
          {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-139" data-mp="18w9sbbg20yae">
              <a href={link.href} className="transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-140" data-mp="18uys1llti8o1">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Cierre */}
        <div className="mt-6 border-t border-rose/10 pt-6" data-id="element-141" data-mp="2l96tw1fhkws3">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-142" data-mp="2l7niao4rz9wn">
            <p className="text-xs text-ink/50" data-id="element-143" data-mp="2q2jiwco2v5ld">
              © 2026 Estética Digital PRO · Creativo Digital. Todos los derechos reservados.
            </p>
            <p className="text-xs text-ink/45" data-id="element-144" data-mp="1xct4s3mg43p9">
              Un producto de{' '}
              <a href="https://creativodigital.shop" target="_blank" rel="noreferrer" className="font-semibold text-rose-deep transition-colors hover:text-rose focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-145" data-mp="22ach2xzl26ek">
                Creativo Digital
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}